export const teamFormUpdate = ({ prop, value }) => {

    return {
        type: 'TEAM_FORM_UPDATE',
        field: { prop, value }
    };
};

export const teamFormError = (message) => {

    return {
        type: 'TEAM_FORM_ERROR',
        message
    };
};

export const teamFormSuccess = (message) => {

    return {
        type: 'TEAM_FORM_SUCCESS',
        message
    };
};

export const teamFormReset = () => {
    
    return {
        type: 'TEAM_FORM_RESET',
    };
}